const doc = [({"se":({"js":({"notification":({"couldnt_submit_because_of_validation_errors":"Det gick inte att skicka på grund av valideringsfel."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;